<!-- ***************************************************************************************************************************** -->
<!--------------------- Form Div for Student Course Grade Estimation --------------------->
<tool-form formTitle="Estimation Filter">
  <form
    [formGroup]="courseEstimationForm"
    (ngSubmit)="courseEstimationAdvisorFormSubmit()"
    class="form-content"
  >
    <!-- Student Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Enter a Student ID</mat-label>
      <input
        type="text"
        matInput
        formControlName="student"
        [matAutocomplete]="studentInfoAuto"
        required
      />
      <button
        *ngIf="courseEstimationForm.value.student"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearStudentInfo()"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-error
        *ngIf="courseEstimationForm.controls['student'].errors?.['required']"
      >
        You must select a student
      </mat-error>
      <mat-error
        *ngIf="courseEstimationForm.controls['student'].errors?.['not_found']"
      >
        Student not found
      </mat-error>
      <mat-autocomplete #studentInfoAuto="matAutocomplete">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [ngStyle]="{ height: studentSelectHeight }"
          itemSize="25"
        >
          <mat-option
            *cdkVirtualFor="let student of studenNamesAndIDsFiltered"
            [value]="student.name + ' (' + student.uwf_id + ')'"
            class="autocomplete-item"
            (onSelectionChange)="getStudentCohortAndProgram(+student.uwf_id)"
          >
            {{ student.name + ' (' + student.uwf_id + ')' }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
    </mat-form-field>

    <!-- Cohort Input Field to display cohort information -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Cohort</mat-label>
      <input type="text" matInput formControlName="cohort" required />
    </mat-form-field>

    <!-- Program Input Field to display program information -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Program</mat-label>
      <input type="text" matInput formControlName="program" required />
    </mat-form-field>

    <!-- Target Semester Dropdown Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Target Semester</mat-label>
      <mat-select
        name="target_semester"
        formControlName="target_semester"
        required
      >
        <mat-option
          *ngFor="let semester of studentAdditionalInfo.semesters"
          [value]="semester.text"
          >{{ semester.text + ' (' + semester.value + ')' }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <!-- Target Course Dropdown Input -->
    <mat-form-field class="filter-form-field" appearance="fill">
      <mat-label>Select a Target Course</mat-label>
      <input
        type="text"
        placeholder="MAC2311"
        matInput
        formControlName="target_course"
        [matAutocomplete]="targetCourseAuto"
        required
      />
      <button
        *ngIf="courseEstimationForm.value.target_course"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearTargetCourseField()"
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-autocomplete #targetCourseAuto="matAutocomplete">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [ngStyle]="{ height: targetCourseSelectHeight }"
          itemSize="25"
        >
          <mat-option
            *cdkVirtualFor="let course of targetCoursefilteredCourses"
            [value]="course"
            class="autocomplete-item"
          >
            {{ course }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>

      <mat-error
        *ngIf="
          courseEstimationForm.controls['target_course'].errors?.['required']
        "
        >You must select a course
      </mat-error>
      <mat-error
        *ngIf="
          courseEstimationForm.controls['target_course'].errors?.['not_found']
        "
        >Course not found or already added in taken courses
      </mat-error>
    </mat-form-field>

    <!-- Display for Course History from Semester Selected -->
    <div class="chip-list-wrapper">
      <!-- 'Fall' should be dynamic because it can be Spring or Summer -->
      <p>Taken Courses</p>

      <mat-chip-listbox #chipList>
        <mat-chip-option
          class="course-mat-chip"
          *ngFor="let course of takenCoursesAndGrades"
          [selectable]="selectable"
          [removable]="removable"
          (removed)="removeCourse(course)"
        >
          {{ course }}
          <mat-icon *ngIf="removable" matChipRemove class="mat-chip-remove">
            cancel
          </mat-icon>
        </mat-chip-option>
      </mat-chip-listbox>

      <div
        class="refresh-button"
        *ngIf="showTakenCoursesReset"
        (click)="resetTakenCourses()"
        matTooltip="Refresh taken courses list"
        matTooltipPosition="right"
      >
        <i class="fa-solid fa-arrows-rotate"></i>
      </div>
    </div>

    <mat-divider style="margin-bottom: 10px"></mat-divider>

    <mat-label>Add additional taken courses and grades</mat-label>

    <form [formGroup]="coursesForm" (ngSubmit)="addCourses()">
      <!-- Course Name Input -->
      <mat-form-field
        class="filter-form-field"
        appearance="fill"
        id="collegeType-input"
        style="margin-top: 10px"
      >
        <mat-label>Select a Course Number</mat-label>
        <input
          type="text"
          placeholder="Example: MAC1105"
          matInput
          formControlName="course"
          [matAutocomplete]="courseToAddAuto"
        />
        <button
          *ngIf="coursesForm.value.course"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="coursesForm.get('course')?.setValue('')"
        >
          <i class="fas fa-times-circle"></i>
        </button>
        <mat-autocomplete #courseToAddAuto="matAutocomplete">
          <cdk-virtual-scroll-viewport
            class="autocomplete-test-viewport"
            [ngStyle]="{ height: courseToAddSelectHeight }"
            itemSize="25"
          >
            <mat-option
              *cdkVirtualFor="let course of courseToAddFilteredCourses"
              [value]="course"
              class="autocomplete-item"
            >
              {{ course }}
            </mat-option>
          </cdk-virtual-scroll-viewport>
        </mat-autocomplete>

        <mat-error *ngIf="coursesForm.controls['course'].errors?.['required']"
          >You must select a course</mat-error
        >
        <mat-error *ngIf="coursesForm.controls['course'].errors?.['not_found']"
          >Course not found or already added in taken courses</mat-error
        >
      </mat-form-field>

      <!-- Course Grade Input -->
      <mat-form-field
        class="filter-form-field"
        appearance="fill"
        id="collegeType-input"
        style="margin-top: 20px"
      >
        <mat-label>Select a Course Grade</mat-label>
        <mat-select
          name="course_grade"
          formControlName="course_grade"
          (selectionChange)="checkDropdown($event)"
        >
          <mat-option value="A">A</mat-option>
          <mat-option value="A-">A-</mat-option>
          <mat-option value="B+">B+</mat-option>
          <mat-option value="B">B</mat-option>
          <mat-option value="B-">B-</mat-option>
          <mat-option value="C+">C+</mat-option>
          <mat-option value="C">C</mat-option>
          <mat-option value="C-">C-</mat-option>
          <mat-option value="D+">D+</mat-option>
          <mat-option value="D">D</mat-option>
          <mat-option value="F">F</mat-option>
          <mat-option value="W">W</mat-option>
        </mat-select>
      </mat-form-field>

      <tool-form-action-button
        text="Add Course"
        [color]="colors['add_course_btn']"
        [textColor]="colors['add_course_btn_text']"
        [disabled]="invalidCourseToAddForm()"
        (onClick)="addCourses()"
      ></tool-form-action-button>
    </form>

    <mat-divider style="margin-bottom: 20px"></mat-divider>

    <!-- Submit Button -->
    <tool-form-action-button
      text="Submit"
      [disabled]="disabledFormSubmitButton()"
      (onClick)="closeDialog()"
    ></tool-form-action-button>

    <tool-form-action-button
      text="View Student"
      type="button"
      *ngIf="
        courseEstimationForm.get('student')?.valid && userRole !== 'student'
      "
      [color]="colors['view_student_btn']"
      textColor="#fff"
      (onClick)="viewStudent()"
    ></tool-form-action-button>
  </form>
</tool-form>
